(() => {
function $ed06e0bb5bd2598b$export$2e2bcd8739ae039() {
    jQuery(".handbruger-menu").on("click", function() {
        jQuery("body").toggleClass("open");
    });
    jQuery(".menu ul li i").on("click", function() {
        jQuery(this).closest("li").addClass("open");
    // jQuery(this).addClass('open');
    // console.log(this);
    // console.log('jj');
    });
    jQuery(".back-wrap").on("click", function() {
        jQuery(this).closest("li").removeClass("open");
    });
// jQuery(".menu ul li").on('click', function() {
//     // Add 'open' class to the closest '.dropdown-wrap' related to the clicked 'li'
//     jQuery(this).closest('.dropdown-wrap').show();
//     console.log("hhh")
// });
// jQuery(".back-wrap").on('click', function() {
//     // Remove 'open' class from the closest '.dropdown-wrap' when 'back-wrap' is clicked
//     jQuery(this).closest('.dropdown-wrap').hide();
//     console.log("hhh-ttt")
// });
// document.addEventListener('DOMContentLoaded', function() {
//     // Select all the li elements
//     const menuItems = document.querySelectorAll('.menu-main-link li');
//     menuItems.forEach((item) => {
//         // Add click event listener to each li element
//         item.addEventListener('click', function() {
//             const dropdown = item.querySelector('.dropdown-wrap');
//             const backWrap = dropdown.querySelector('.back-wrap');
//             // Show the dropdown-wrap when li is clicked
//             dropdown.style.opacity = 1;
//             dropdown.style.pointerEvents = 'all';
//             // Hide dropdown-wrap when back-wrap is clicked
//             backWrap.addEventListener('click', function() {
//                 dropdown.style.opacity = 0;
//                 dropdown.style.pointerEvents = 'none';
//             });
//         });
//     });
// });
}


function $d8e4f30d8b9bc8d7$export$2e2bcd8739ae039() {
    jQuery(".responsive").slick({
        dots: false,
        infinite: true,
        speed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        // arrows: true,
        prevArrow: '<svg class="prevArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><rect width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0)" fill="#0FF"/><path d="M35.025 24.462H14.118" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="round"/><path d="m22.55 32.965-8.432-8.433M22.55 15.894l-8.433 8.433" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="square"/></svg>',
        nextArrow: '<svg class="nextArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><rect width="49" height="49" rx="24.5" fill="#0FF"/><path d="M13.975 24.462h20.907" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="round"/><path d="m26.45 32.965 8.433-8.433M26.45 15.894l8.433 8.433" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="square"/></svg>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: true,
                    centerPadding: "0px"
                }
            }
        ]
    });
}


function $5f6dad96d1a97a28$export$2e2bcd8739ae039() {
    jQuery(".brandSLider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: ".brandSliderSingle",
        focusOnSelect: true,
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "100px"
                }
            }
        ]
    });
    jQuery(".brandSliderSingle").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<svg class="prevArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><rect width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0)" fill="#0FF"/><path d="M35.025 24.462H14.118" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="round"/><path d="m22.55 32.965-8.432-8.433M22.55 15.894l-8.433 8.433" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="square"/></svg>',
        nextArrow: '<svg class="nextArrow" xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><rect width="49" height="49" rx="24.5" fill="#0FF"/><path d="M13.975 24.462h20.907" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="round"/><path d="m26.45 32.965 8.433-8.433M26.45 15.894l8.433 8.433" stroke="#1B0B5E" stroke-width="1.75" stroke-linecap="square"/></svg>',
        asNavFor: ".brandSLider",
        centerMode: true,
        centerPadding: "100px",
        draggable: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerPadding: "0px"
                },
                breakpoint: 991,
                settings: {
                    dots: true,
                    centerPadding: "0px"
                }
            }
        ]
    });
}


function $0f7657d608b00b77$export$2e2bcd8739ae039() {
    const $ = jQuery;
    $(document).on("ready", function() {
        $(".vertical-slider").slick({
            dots: false,
            infinite: true,
            arrows: false,
            vertical: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            speed: 5000,
            autoplaySpeed: 0,
            cssEase: "linear",
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        vertical: false,
                        variableWidth: true,
                        speed: 3000
                    }
                }
            ]
        });
        $(".vertical-slider-rtl").slick({
            dots: false,
            infinite: true,
            arrows: false,
            vertical: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: true,
            speed: 5000,
            autoplaySpeed: 0,
            cssEase: "linear",
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        vertical: false,
                        variableWidth: true,
                        speed: 3000
                    }
                }
            ]
        });
    });
}


function $8128e6989dfc41c3$export$2e2bcd8739ae039() {
    const $ = jQuery;
    $(window).on("load", function() {
        $(".enro-scroll-x").mCustomScrollbar({
            axis: "x",
            mouseWheel: "disable",
            advanced: {
                autoExpandHorizontalScroll: true
            },
            scrollButtons: {
                enable: true,
                scrollAmount: 410,
                scrollType: "stepped"
            },
            callbacks: {
                onTotalScroll: function() {
                //  loadMoreContent(); // Function to load more content
                }
            }
        });
    });
}


function $edf25e9c7681cd46$export$2e2bcd8739ae039() {
    const $ = jQuery;
    $(window).on("load", function() {
        var owl2 = $(".owl-scrollingLogoRight");
        owl2.owlCarousel({
            center: true,
            autoWidth: true,
            loop: true,
            items: 4,
            margin: 15,
            rtl: false,
            autoplay: true,
            slideTransition: "linear",
            autoplayTimeout: 6000,
            autoplaySpeed: 6000,
            mouseDrag: false
        });
        var owl3 = $(".owl-scrollingLogoLeft");
        owl3.owlCarousel({
            center: true,
            autoWidth: true,
            loop: true,
            items: 4,
            margin: 15,
            autoplay: true,
            rtl: true,
            slideTransition: "linear",
            autoplayTimeout: 6000,
            autoplaySpeed: 6000,
            mouseDrag: false
        });
    });
}


function $1f3c8d9c7ccaf93f$export$2e2bcd8739ae039() {
    const $ = jQuery;
    $(window).on("load", function() {
        var owl = $(".owl-culture");
        owl.owlCarousel({
            center: true,
            autoHeight: true,
            //autoWidth:true,
            loop: true,
            margin: 0,
            items: 1
        });
    });
}


function $a47a2b901812b4a5$export$2e2bcd8739ae039() {
    const $ = jQuery;
    jQuery("#verticalTaba").easyResponsiveTabs({
        type: "vertical",
        width: "auto",
        fit: true
    });
}


function $b268cb670c24e802$export$2e2bcd8739ae039() {
    const $ = jQuery;
    const postList = document.querySelector("#postList");
    if (postList) {
        $(".filterSelect").on("change", function() {
            const year = $(this).val();
            const posttype = $(this).data("posttype");
            const listinglayout = $(this).data("listinglayout");
            const numposts = $(this).data("numposts");
            const postnotin = $(this).data("postnotin");
            const tags_in = $(this).data("tagsin");
            const searchTerm = $(".filterSearchfor").val() || "";
            const tag = $(".filterSelectTag").val() || "";
            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`, function(data) {
                if (data != "</section>") postList.innerHTML = data;
                else postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
            // postList.innerHTML = data
            });
        });
        $(".filterSearchfor").on("input", function() {
            // console.log("...")
            const searchTerm = $(this).val();
            // console.log("Search term:", searchTerm);
            const posttype = $(this).data("posttype");
            const listinglayout = $(this).data("listinglayout");
            const numposts = $(this).data("numposts");
            const postnotin = $(this).data("postnotin");
            const tags_in = $(this).data("tagsin");
            const year = $(".filterSelect").val() || "";
            const tag = $(".filterSelectTag").val() || "";
            // console.log(year)
            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`, function(data) {
                // console.log(data);
                if (data != "</section>") postList.innerHTML = data;
                else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                    console.log("not found result..");
                }
            });
        });
        $(".filterSelectTag").on("change", function() {
            const tag = $(this).val();
            // console.log(tag);
            // console.log("Search term:", searchTerm);
            const posttype = $(this).data("posttype");
            const listinglayout = $(this).data("listinglayout");
            const numposts = $(this).data("numposts");
            const postnotin = $(this).data("postnotin");
            const tags_in = $(this).data("tagsin");
            const year = $(".filterSelect").val() || "";
            const searchTerm = $(".filterSearchfor").val() || "";
            // console.log(theme_url); // http://localhost:8888/enero/wp-content/themes/enero-2023
            // console.log(`${theme_url}/blocks/loophandlers/m13-handler.php`)
            // console.log(`?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`)
            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`, function(data) {
                // console.log(data);
                // postList.innerHTML = data;
                if (data != "</section>") postList.innerHTML = data;
                else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                    console.log("not found result..");
                }
            });
        });
        $(postList).on("click", ".pagination ul li", function() {
            if ($(this).hasClass("disabled") || $(this).hasClass("current")) // alert($(this).attr('class'))
            return;
            const paginationLiEl = $(this);
            const page = paginationLiEl.data("page");
            const paginationEl = paginationLiEl.parents(".pagination");
            const posttype = paginationEl.data("posttype");
            const listinglayout = paginationEl.data("listinglayout");
            const numposts = paginationEl.data("numposts");
            const postnotin = paginationEl.data("postnotin");
            // const tags_in = $(this).data('tagsin');
            // const searchTerm = $('.filterSearchfor').val();
            // const tag = $('.filterSelectTag').val();
            // const year = $('.filterSelect').val();
            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=${page}&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}${paginationEl.data("year") ? `&year=${paginationEl.data("year")}` : ""}`, function(data) {
                // postList.innerHTML = data
                if (data != "</section>") postList.innerHTML = data;
                else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                    console.log("not found result..");
                }
            });
        });
    }
}


function $f33d5a0f7db50bf3$export$2e2bcd8739ae039() {
    const $ = jQuery;
    $(window).on("load", function() {
        var owl5 = $(".owl-carousel");
        owl5.owlCarousel({
            center: true,
            autoWidth: true,
            loop: true,
            items: 4,
            margin: 60,
            autoplay: true,
            slideTransition: "linear",
            autoplayTimeout: 2000,
            autoplaySpeed: 6000,
            nav: false,
            dots: false,
            responsive: {
                992: {
                    margin: 60
                },
                0: {
                    margin: 20
                }
            }
        });
    });
}


function $fc0174c0f0c97ee9$export$2e2bcd8739ae039() {
    const $ = jQuery;
    const slider = $(".slick-agencyWork");
    slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        focusOnSelect: true,
        infinite: true,
        vertical: true,
        verticalSwiping: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: true
                }
            }
        ]
    });
    let debounceTimer;
    // Wheel event listener with debounce
    slider.on("wheel", function(e) {
        e.preventDefault();
        clearTimeout(debounceTimer); // Clear previous debounce timer
        debounceTimer = setTimeout(()=>{
            if (e.originalEvent.deltaY < 0) $(this).slick("slickPrev"); // Move to the previous slide
            else $(this).slick("slickNext"); // Move to the next slide
        }, 40); // Adjust debounce duration as needed
    });
    // Optionally, add logic for custom scroll bar
    const scrollset = ()=>{
        const totalSlides = slider.slick("getSlick").slideCount;
        const parentHeight = $(".scroll-content").outerHeight();
        const barHeight = parentHeight / totalSlides;
        const barHeightPercentage = barHeight / parentHeight * 100;
        $(".slide-bar").css("height", barHeightPercentage + "%");
        for(let index = 0; index < totalSlides; index++)$(`.slide-bar-${index}`).css("top", barHeightPercentage * index + "%");
    };
    slider.on("afterChange", scrollset);
    scrollset();
}


function $0f54a03fc2fa4b87$export$2e2bcd8739ae039() {
    //$(window).resize(function(){
    const $ = jQuery;
    $(document).ready(function() {
        if ($(window).width() <= 991) {
            var li_width = 0;
            $(".tab-outer-wrap .resp-tabs-list li").each(function() {
                li_width += $(this).outerWidth();
            });
            $(".tab-outer-wrap .resp-tabs-list").width(li_width);
        }
        $("#verticalTab").easyResponsiveTabs({
            type: "vertical",
            width: "auto",
            fit: true
        });
    });
    //});
    Fancybox.bind("[data-fancybox]", {});
    $(document).on("click", ".scroll-trigger", function(e) {
        e.preventDefault(); // Prevent default action if necessary
        $("html, body").animate({
            scrollTop: $(".tab-outer-wrap").offset().top
        }, 1000); // 1000ms animation (1 second)
    });
}


function $000cf92174a00c1d$export$2e2bcd8739ae039() {
    const $ = jQuery;
    $(document).ready(function() {
        new $.Zebra_Accordion("#Zebra_Accordion1");
    });
}


function $aa742e2e96da592f$export$2e2bcd8739ae039() {
    const $ = jQuery;
    jQuery("#verticalTab").easyResponsiveTabs({
        type: "vertical",
        width: "auto",
        fit: true
    });
}


function $9d14c4bb0e206468$export$2e2bcd8739ae039() {
    const $ = jQuery;
    const work = document.querySelector("#works");
    if (work) jQuery(work).on("click", ".pagination ul li", function() {
        if ($(this).hasClass("disabled") || $(this).hasClass("current")) {
            alert($(this).attr("class"));
            return;
        }
        const page = $(this).data("page");
        $.get(`${theme_url}/blocks/loophandlers/work-handler.php?numPosts=6&pageNumber=${page}`, function(data) {
            work.innerHTML = data;
        });
    });
}


function $e302dbfcc8e25f93$export$2e2bcd8739ae039() {
    const $ = jQuery;
    const formatState = (state)=>{
        if (!state.id) return state.text;
        const $state = $("<strong></strong>");
        $state.text(state.text);
        $(".clearWrap").show();
        return $state;
    };
    $(".filterSelect").each(function() {
        $(this).select2({
            placeholder: $(this).data("type"),
            selectOnClose: true,
            minimumResultsForSearch: Infinity,
            dropdownParent: $(this).parent(),
            templateSelection: formatState
        });
    });
}


function $ad82b0e3d11e3fc8$export$2e2bcd8739ae039() {
    const links = jQuery(".lottieLinks");
    const bannerEle = jQuery("#bannerAnimations");
    if (links.length > 0) {
        let currentLinkIndex = 0;
        const speed = bannerEle.data("speed") * 1000;
        setInterval(()=>{
            if (links.children().length > currentLinkIndex + 1) currentLinkIndex++;
            else currentLinkIndex = 0;
        }, speed);
        bannerEle.on("click", function() {
            const linkTarget = jQuery(links.children()[currentLinkIndex]).text();
            window.location.href = linkTarget;
        });
    }
}


function $789a9c7a8fa4407b$export$2e2bcd8739ae039() {
    jQuery(".brandLogo").on("click", function() {
        const targetId = jQuery(`#${jQuery(this).data("target")}`);
        jQuery("html, body").animate({
            scrollTop: targetId.offset().top
        }, 2000);
    });
    function translateY(element, y = 0) {
        element.style.transform = `translateY(${y})`;
        element.style.webkitTransform = `translateY(${y})`;
        element.style.mozTransform = `translateY(${y})`;
        element.style.msTransform = `translateY(${y})`;
        element.style.oTransform = `translateY(${y})`;
    }
    const spans = document.querySelectorAll(".rotater span");
    let index = 0;
    let prev = -1;
    function animate() {
        spans.forEach((span, i)=>{
            // span.style.opacity = i === index ? 1 : 0; 
            // setTimeout(() => {
            //     // console.log("index:"+index)
            //     span.style.opacity = i === index ? 1 : 0; 
            //     if(index === i) {
            //         console.log('index'+ index);
            //     }
            // }, 2000);
            if (prev === i) {
                // setTimeout(() => {
                translateY(span, "-30px");
                span.style.opacity = 0;
            // }, 1000)
            } else if (index === i) setTimeout(()=>{
                console.log(span);
                span.style.opacity = 1;
                translateY(span, "0px");
            }, 1500);
            else // setTimeout(() => {
            translateY(span, "30px");
        });
        prev = index;
        index = (index + 1) % spans.length;
        console.log(index);
        setTimeout(()=>requestAnimationFrame(animate), 4000); // 2-second delay
    }
    animate();
}


function $d0d3577e45c76f7b$export$2e2bcd8739ae039() {
    const $ = jQuery;
    // const postList = document.querySelector('#postList')
    const postsList = document.querySelectorAll(".postList");
    $(document).ready(function() {
        if (postsList) {
            $(".filterSelect").on("change", function() {
                const year = $(this).val();
                const posttype = $(this).data("posttype");
                const listinglayout = $(this).data("listinglayout");
                const numposts = $(this).data("numposts");
                const postnotin = $(this).data("postnotin");
                const tags_in = $(this).data("tagsin");
                const searchTerm = $(".filterSearchfor").val() || "";
                const tag = $(".filterSelectTag").val() || "";
                const repeater_rows_count = $(this).data("repeaterrow");
                const postList = document.querySelector(`#postList-${repeater_rows_count}`);
                // console.log(repeater_rows_count);
                // console.log(`#postList-${repeater_rows_count}`);
                // console.log(postList);
                $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}&repeaterrow=${repeater_rows_count}`, function(data) {
                    if (data != "</section>") postList.innerHTML = data;
                    else postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                // postList.innerHTML = data
                });
            });
            $(".filterSearchfor").on("input", function() {
                // console.log("...")
                const searchTerm = $(this).val();
                // console.log("Search term:", searchTerm);
                const posttype = $(this).data("posttype");
                const listinglayout = $(this).data("listinglayout");
                const numposts = $(this).data("numposts");
                const postnotin = $(this).data("postnotin");
                const tags_in = $(this).data("tagsin");
                const year = $(".filterSelect").val() || "";
                const tag = $(".filterSelectTag").val() || "";
                const repeater_rows_count = $(this).data("repeaterrow");
                const postList = document.querySelector(`#postList-${repeater_rows_count}`);
                // console.log(year)
                $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}&repeaterrow=${repeater_rows_count}`, function(data) {
                    // console.log(data);
                    if (data != "</section>") postList.innerHTML = data;
                    else {
                        postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                        console.log("not found result..");
                    }
                });
            });
            $(".filterSelectTag").on("change", function() {
                const tag = $(this).val();
                // console.log(tag);
                // console.log("Search term:", searchTerm);
                const posttype = $(this).data("posttype");
                const listinglayout = $(this).data("listinglayout");
                const numposts = $(this).data("numposts");
                const postnotin = $(this).data("postnotin");
                const tags_in = $(this).data("tagsin");
                const year = $(".filterSelect").val() || "";
                const searchTerm = $(".filterSearchfor").val() || "";
                const repeater_rows_count = $(this).data("repeaterrow");
                const postList = document.querySelector(`#postList-${repeater_rows_count}`);
                // console.log(theme_url); // http://localhost:8888/enero/wp-content/themes/enero-2023
                // console.log(`${theme_url}/blocks/loophandlers/m13-handler.php`)
                // console.log(`?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`)
                $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}&repeaterrow=${repeater_rows_count}`, function(data) {
                    // console.log(data);
                    // postList.innerHTML = data;
                    if (data != "</section>") postList.innerHTML = data;
                    else {
                        postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                        console.log("not found result..");
                    }
                });
            });
            postsList.forEach((postList)=>{
                // console.log('wow');
                // console.log(post);
                $(postList).on("click", ".pagination ul li", function() {
                    // console.log('hii...');
                    if ($(this).hasClass("disabled") || $(this).hasClass("current")) // alert($(this).attr('class'))
                    return;
                    const paginationLiEl = $(this);
                    const page = paginationLiEl.data("page");
                    const paginationEl = paginationLiEl.parents(".pagination");
                    const posttype = paginationEl.data("posttype");
                    const listinglayout = paginationEl.data("listinglayout");
                    const numposts = paginationEl.data("numposts");
                    const postnotin = paginationEl.data("postnotin");
                    const repeater_rows_count = paginationEl.data("repeaterrow");
                    const postList = document.querySelector(`#postList-${repeater_rows_count}`);
                    $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=${page}&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}${paginationEl.data("year") ? `&year=${paginationEl.data("year")}` : ""}${paginationEl.data("searchTerm") ? `&searchTerm=${paginationEl.data("searchTerm")}` : ""}${paginationEl.data("havetags") ? `&tags=${paginationEl.data("havetags")}` : ""}&repeaterrow=${repeater_rows_count}`, function(data) {
                        // postList.innerHTML = data
                        if (data != "</section>") postList.innerHTML = data;
                        else {
                            postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>" + data;
                            console.log("not found result..");
                        }
                    });
                });
            });
        // $(postList).on('click','.pagination ul li',function(){
        //     console.log('hii...');
        //     if($(this).hasClass('disabled') || $(this).hasClass('current')){
        //         // alert($(this).attr('class'))
        //         return
        //     }
        //     const paginationLiEl=$(this);
        //     const page = paginationLiEl.data("page")
        //     const paginationEl=paginationLiEl.parents('.pagination');
        //     const posttype = paginationEl.data("posttype");
        //     const listinglayout = paginationEl.data("listinglayout");
        //     const numposts = paginationEl.data("numposts");
        //     const postnotin = paginationEl.data("postnotin");
        //     const repeater_rows_count = paginationEl.data("repeaterrow");
        //     // const tags_in = $(this).data('tagsin');
        //     // const searchTerm = $('.filterSearchfor').val();
        //     // const tag = $('.filterSelectTag').val();
        //     // const year = $('.filterSelect').val();
        //     // const repeater_rows_count = $(this).data('repeaterrow');
        //     const postList = document.querySelector(`#postList-${repeater_rows_count}`);
        //     $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=${page}&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}${paginationEl.data("year") ? `&year=${paginationEl.data("year")}` : ""}&repeaterrow=${repeater_rows_count}`,function(data){
        //         // postList.innerHTML = data
        //         if(data != "</section>"){
        //             postList.innerHTML = data;
        //         } else {
        //             postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>"+data;
        //             console.log("not found result..");
        //         }
        //     })
        // });
        }
    });
}


function $1d86db5f665f5e58$export$2e2bcd8739ae039() {
    console.log("Ram...!");
    const workbannerscroller = document.querySelector(".work-banner-scroller");
    const header = document.querySelector(".header");
    if (workbannerscroller) {
        const parent = workbannerscroller.parentElement;
        let parentHeight = 0, headerHeight = 0;
        if (parent) // Get the height of the parent element
        parentHeight = parent.offsetHeight;
        if (header) // Get the height of the parent element
        headerHeight = header.offsetHeight;
        let scrollAmount = headerHeight + parentHeight;
        workbannerscroller.addEventListener("click", ()=>{
            console.log("vvvv");
            window.scrollBy({
                // top: 600, // Scroll vertically by 500px
                top: scrollAmount,
                left: 0,
                behavior: "smooth"
            });
        });
        console.log(workbannerscroller);
    }
}


(0, $ed06e0bb5bd2598b$export$2e2bcd8739ae039)();
(0, $d8e4f30d8b9bc8d7$export$2e2bcd8739ae039)();
(0, $ad82b0e3d11e3fc8$export$2e2bcd8739ae039)();
(0, $5f6dad96d1a97a28$export$2e2bcd8739ae039)();
(0, $0f7657d608b00b77$export$2e2bcd8739ae039)();
(0, $8128e6989dfc41c3$export$2e2bcd8739ae039)();
(0, $edf25e9c7681cd46$export$2e2bcd8739ae039)();
(0, $1f3c8d9c7ccaf93f$export$2e2bcd8739ae039)();
(0, $a47a2b901812b4a5$export$2e2bcd8739ae039)();
(0, $b268cb670c24e802$export$2e2bcd8739ae039)();
(0, $f33d5a0f7db50bf3$export$2e2bcd8739ae039)();
(0, $fc0174c0f0c97ee9$export$2e2bcd8739ae039)();
(0, $0f54a03fc2fa4b87$export$2e2bcd8739ae039)();
(0, $000cf92174a00c1d$export$2e2bcd8739ae039)();
(0, $aa742e2e96da592f$export$2e2bcd8739ae039)();
(0, $789a9c7a8fa4407b$export$2e2bcd8739ae039)();
(0, $9d14c4bb0e206468$export$2e2bcd8739ae039)();
(0, $e302dbfcc8e25f93$export$2e2bcd8739ae039)();
(0, $d0d3577e45c76f7b$export$2e2bcd8739ae039)();
(0, $1d86db5f665f5e58$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=main.js.map
